import { render, staticRenderFns } from "./ChatRoomManage.vue?vue&type=template&id=d1682656&scoped=true"
import script from "./ChatRoomManage.vue?vue&type=script&lang=js"
export * from "./ChatRoomManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1682656",
  null
  
)

export default component.exports